/* ============================================================================
   Phone menu panel (sections/header.liquid)
   ----------------------------------------------------------------------------
   Opens from the Menu button, closes from the X (same spot), the backdrop,
   Escape, or following any link in it. Focus moves into the panel, is kept
   there while it is open, and returns to the Menu button on close. The page
   behind is scroll-locked. Widening past the phone breakpoint closes it.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-mnav]');
  var openBtn = document.querySelector('[data-mnav-open]');
  if (!root || !openBtn) return;

  var panel = root.querySelector('.mnav__panel');
  var hideTimer = null;

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open() {
    clearTimeout(hideTimer);
    root.hidden = false;
    /* next frame, so the slide-in transition runs from the hidden state */
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mnav-lock');
    var close = panel.querySelector('.mnav__close');
    if (close) close.focus();
  }

  function close(returnFocus) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mnav-lock');
    hideTimer = setTimeout(function () { root.hidden = true; }, 260);
    if (returnFocus !== false) openBtn.focus();
  }

  openBtn.addEventListener('click', open);

  root.querySelectorAll('[data-mnav-close]').forEach(function (el) {
    el.addEventListener('click', function () { close(); });
  });

  /* Following a link closes the panel first, so an in-page anchor lands on
     a page that can scroll again. */
  panel.querySelectorAll('a[href]').forEach(function (a) {
    a.addEventListener('click', function () { close(false); });
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  if (window.matchMedia) {
    var wide = window.matchMedia('(min-width: 721px)');
    var onWide = function (e) { if (e.matches) close(false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }
})();
